class Slider {
  constructor() {
    this.init();
  }

  init() {
    const swiper = new Swiper(".swiper", {
      speed: 600,
      loop: true,
      autoplay: true,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '[data-slider="lp-slider"] .swiper-button-next',
        prevEl: '[data-slider="lp-slider"] .swiper-button-prev'
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Slider();
});


document.addEventListener('DOMContentLoaded', () => {
  // 全てのアンカーリンクを取得
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  console.log('アンカーリンク');

  // 各アンカーリンクにクリックイベントを追加
  anchorLinks.forEach(link => {
      link.addEventListener('click', (event) => {
          event.preventDefault();
          console.log('click!!!');

          const targetId = link.getAttribute('href').substring(1);
          const targetElement = document.getElementById(targetId);

          if (targetElement) {
              const offset = 0;
              const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

              window.scrollTo({
                  top: targetPosition,
                  behavior: 'smooth'
              });
          }
      });
  });
});

document.querySelectorAll(".lp-btn a, .lp-fixed-icon a").forEach(function (button) {
  const purchaseUrl = button.getAttribute("href");
  const currentPageUrl = window.location.href;
  const checkUrl = `https://www.miruto.shop/pages/cartcheck/?purchase=${encodeURIComponent(
    purchaseUrl,
  )}&lp=${encodeURIComponent(currentPageUrl)}`;
  button.setAttribute("href", checkUrl);
  button.setAttribute("target", "_blank");
});

// document.querySelectorAll('.lp-btn a, .lp-fixed-icon a').forEach(function(button) {
//   button.addEventListener('click', function(event) {
//       event.preventDefault();

//       const purchaseUrl = this.href;
//       const currentPageUrl = window.location.href;
//       const checkUrl = `https://www.miruto.shop/pages/cartcheck/?purchase=${encodeURIComponent(purchaseUrl)}&lp=${encodeURIComponent(currentPageUrl)}`;

//       window.open(checkUrl, '_self');
//   });
// });
